/**
 * ADR-013：ai_session_messages.message_type 枚举（与后端 AISessionMessageType 对齐）。
 */
export const AISessionMessageType = {
  ASSISTANT_TEXT: 1,
  USER_TEXT: 2,
  SYSTEM_NOTICE: 3,
  CLARIFICATION: 4,
  STAGE_INTRO: 5,
  RUN_ACTION_STATUS: 6,
  MUTATION_MISS: 7,
  STORYBOARD_RECOVERABLE_FAILURE: 8,
  STORYBOARD_EDIT_CLARIFICATION: 9,
} as const;

export type AISessionMessageTypeValue =
  (typeof AISessionMessageType)[keyof typeof AISessionMessageType];
